import React from "react";
import {Container, Row, Col} from "react-bootstrap";
import {
  APP_SECTION, STORAGE_KEYS
} from "../../../scripts/constants";
import {saveApplication, startApplication} from "../../../scripts/sync-manager";
import {mygaSession} from "../../../scripts/myga-session";
import AppContentWrapper from "../AppContentWrapper/AppContentWrapper";
import MYGAStrings from "../../../Resources/Content/MYGAStrings";
import {NassauLog} from "../../../scripts/myga-utils";
import {PageManager} from "../../../scripts/page-manager";
import Question from "../../../components/Questions/Question";
import {areFinancialObjectivesOK, hasPrimaryBenes} from "../../../scripts/validation";

class NeedsFL extends React.Component {
  
  constructor(props) {
    super(props);

    // Load the component state from the current application
    this.state = {
      errorMessage: '',
      needs: mygaSession.getCurrentAppNeeds(),
      appStateAbbr: mygaSession.getMygaSessionValue(STORAGE_KEYS.AppStateAbbr)
    };
  
  }
  
  componentDidMount() {
    
    // Get the current application
    let app = mygaSession.getCurrentApp();
    if (app===null) {
      
      // request a new application from the backend
      startApplication()
          .then((data)=>{
            NassauLog("app: " + JSON.stringify(data));
            let needs = mygaSession.getCurrentAppFinances();
            this.setState({
              needs
            })
          })
          .catch((err) => {
            NassauLog(err);
            // TODO: Handle the error. Message popup?
          });
      
    } else {
      // OK continue on.
    }
  }
  
  validate = () => {
    
    // 2021.07.16.ADivelbiss - onNext Validation
    if (!this.pageForm.checkValidity()) {
      this.pageForm.classList.add('was-validated');
      // 2022.04.27.ADivelbiss - check areFinancialObjectivesOK first
      if (!areFinancialObjectivesOK({[APP_SECTION.needs]: this.state.needs})) {
        this.setState({
          errorMessage: MYGAStrings.Finances_ErrorFinancialObjectivesFL
        });
      } else {
        this.setState({
          errorMessage: MYGAStrings.Finances_ErrorMissingInformation
        });
      }
      return false;
    }
    
    return true;
  };
    
    saveApplication = async () => {
    // populate finance object from fields
    let needs = this.state.needs;

    // Update the current application
    mygaSession.setCurrentAppSectionData(APP_SECTION.needs,needs);
  
    await saveApplication(APP_SECTION.needs)
  };
  
  handleChange = (field) => (e) => {
    let needs = this.state.needs;
    let value =  e.target && e.target.value!==undefined ? e.target.value : e;
    NassauLog(`NeedsFL.handleChange: ${field} = ${value}`);
    needs[field] = value;

    this.setState({
      needs: needs,
      errorMessage:''
    });
  };
  
  render() {

    return (
    
        <AppContentWrapper
            onBackPressed={this.saveApplication}
            onNextPressed={this.saveApplication}
            validateOnNext={this.validate}
            updatePage={this.props.updatePage}
            errorMessage={this.state.errorMessage}>
  
          <form className={'needs-validation'}
                ref={(form) => {
                  this.pageForm = form;
                }}>
            <Container>
  
              {/*  Explanation */}
              <Container>
                <Row className="page-question pt-0 mt-0">
                  <Col className=" text-center pb-3">
                    <div>Tell us about your needs...</div>
                  </Col>
                </Row>
              </Container>
          
              {/* Questions */}
              <Container className={'pb-sm-5'}>
                <Question
                  containerClass={'pb-4 pl-4 pl-md-5'}
                  question={PageManager.getQuestionByName('purchaseReasonFL')}
                  data={this.state.needs}
                  onChange={this.handleChange}
                />
                <Question
                  containerClass={'pb-4 pl-4 pl-md-5'}
                  questionClass={'text-xs-left text-sm-center'}
                  question={PageManager.getQuestionByName('financialObjectivesFL')}
                  data={this.state.needs}
                  onChange={this.handleChange}
                />
                <Question
                  containerClass={'pb-1 pl-4 pl-md-5'}
                  question={PageManager.getQuestionByName('riskToleranceFL')}
                  data={this.state.needs}
                  onChange={this.handleChange}
                  />
                <Question
                  containerClass={'offset-lg-2 col-lg-8 pb-5 pl-4 pl-md-5'}
                  question={PageManager.getQuestionByName('riskToleranceCommentsFL')}
                  data={this.state.needs}
                  onChange={this.handleChange}
                />
                {/*<Question*/}
                {/*  containerClass={'pb-4 pl-4 pl-md-5'}*/}
                {/*  question={PageManager.getQuestionByName('fedIncomeTaxBracketFL')}*/}
                {/*  data={this.state.needs}*/}
                {/*  onChange={this.handleChange}*/}
                {/*/>*/}
                <Question
                  containerClass={'pb-4 pl-4 pl-md-5'}
                  question={PageManager.getQuestionByName('investmentExperienceFL')}
                  data={this.state.needs}
                  onChange={this.handleChange}
                />
              </Container>
            </Container>
          </form>
        </AppContentWrapper>
    );

  }
}

export default NeedsFL;